import { publicInstance } from "../axios";
import { AUTH_SESSION_NAME, LOCAL_SESSION_TOKEN_NAME } from "../helpers/config";


export const isAuthenticated = () => {
  const userSession = getUserSession();
  if (userSession && userSession.authToken) {
    return true;
  }
  return false;
};
export const isGuest = () => {
  const userSession = getUserSession();
  if (userSession && userSession.userType === 2) {
    return true;
  }
  return false;
};
export const haveAccess = (group) => {
  let userSession = localStorage.getItem(AUTH_SESSION_NAME);

  if (userSession) {
    userSession = JSON.parse(userSession);
    if (group.includes(userSession.role)) {
      return true;
    } else return false;
  }

  return false;
};
export const getUserSession = () => {
  const userSession = localStorage.getItem(AUTH_SESSION_NAME);
  if (userSession) return JSON.parse(userSession);
  return {};
};
export const setUserSession = (data) => {
  localStorage.setItem(AUTH_SESSION_NAME, JSON.stringify(data));

  return {};
};
export const clearUserSession = () => {
  localStorage.removeItem(AUTH_SESSION_NAME);
};

export const setLocalSession = () => {
  let oldSession = getLocalSession();
  if (oldSession) {
    return false;
  }
  let length = "30";
  let randomChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += randomChars.charAt(
      Math.floor(Math.random() * randomChars.length)
    );
  }
  localStorage.setItem(LOCAL_SESSION_TOKEN_NAME, result);
};
export const refreshLocalSession = () => {
  let length = "30";
  let randomChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += randomChars.charAt(
      Math.floor(Math.random() * randomChars.length)
    );
  }
  localStorage.setItem(LOCAL_SESSION_TOKEN_NAME, result);
};

export const getLocalSession = () => {
  return localStorage.getItem(LOCAL_SESSION_TOKEN_NAME);
};
export const loginAction = async (formData) => {
  try {
    const res = await publicInstance.post("login", formData);

    if (res.status === 200 && res.data.message === "success") {
      const userData = res.data.data;
      

      const { authToken, email, user_id, name,lastname } = userData;
      

      localStorage.setItem(
        AUTH_SESSION_NAME,
        JSON.stringify({ authToken, email, user_id, name, lastname })
      );

      return res.status;
    } else {
      return res.data.message;
    }
  } catch (error) {
    return "API error";
  }
};

export const loginWithOTP = async (formData) => {
  try {
    const res = await publicInstance.post("loginwithOTP", formData);
      console.log(res);
      if (res.status === 200) {
        return res.data;
      } else {
        return res.data.message;
      }
  } catch (error) {
    return "API error";
  }
};

export const registerAction = async (formData) => {

  return await publicInstance
    .post("register", formData)
    .then((res) => {
      console.log(res);
      if (res.status === 200) {
        return res.data;
      } else {
        return res.data.message;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const verifyOtpAction = async (formData) => {
  
  const submitData = {
    otp: `${formData.otp}`,
    email: formData.email,
  };
  console.log('verifyOtpAction');
  console.log(submitData);
  return await publicInstance
    .post("verify-otp", submitData)
    .then((res) => {
       console.log(res);
        if (res.status === 200 && res.data.message === "success") {
      const userData = res.data.data;
      

      const { authToken, email, user_id, name,lastname } = userData;
      

      localStorage.setItem(
        AUTH_SESSION_NAME,
        JSON.stringify({ authToken, email, user_id, name, lastname })
      );

      return res;
    
      } else {
        return res.data.message;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const resendOtpAction = async (formData) => {
  
  const submitData = {
  
    email: formData.email,
  };
  return await publicInstance
    .post("resend-otp", submitData)
    .then((res) => {
       console.log(res);
        if (res.status === 200 && res.data.result === true) {
   

      return res.status;
    
      } else {
        return res.data.message;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
export const logoutAction = async (authToken,userId,navigate) => {
   const submitData = {
        authToken: authToken,
        userId
  };
   localStorage.clear();
   
  return publicInstance
    .post("/logout",submitData)
    .then((res) => {
      // console.log("logout");
      // console.log(res);
      // if (res.status === 200) {
      //   localStorage.clear();
      //   return 1;
      // } else {
      //   return 0;
      // }
      navigate("/");
    })
    .catch((error) => {
    navigate("/");
    });

  
};

export const forgotPasswordAction = async (formData) => {
  return await publicInstance
    .post("forgot-password", formData)
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        return res.data.message;
      }
    })
    .catch((error) => {
      return "API error";
    });
};

export const resetPasswordAction = async (formData) => {
  const submitData = {
    otp: `${formData.otp1}${formData.otp2}${formData.otp3}${formData.otp4}${formData.otp5}`,
    
    password: formData.password,
    email: formData.email,
  };

  return await publicInstance
    .post("set-new-password", submitData)
    .then((res) => {
      if (res.status === 200) {
        return res.status;
      } else {
        return res.data.message;
      }
    })
    .catch((error) => {
      return "API error";
    });
};
